export default function RP_108() {

    return <>
        <p> <img src="https://image.kr.canon/pds/editor/upload/editor/accessory/printer/rp108/rp_108_img01.jpg" width="98%" /> </p>
        <p> <img src="https://image.kr.canon/pds/editor/upload/editor/accessory/printer/rp108/rp_108_img02.jpg" width="98%" /> </p>
        <p> <img src="https://image.kr.canon/pds/editor/upload/editor/accessory/printer/rp108/rp_108_img03.jpg" width="98%" /> </p>
        <p> <img src="https://image.kr.canon/pds/editor/upload/product/accessory/KC-36IP/img01.jpg" width="98%" /> </p>
    </>
}